import React, {
  useState,
  useEffect,
} from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import MainHeader from '../../components/MainHeader'
import MainView from '../../components/MainView'
import DealerDetails from '../../components/DealerDetails'
import DealerJobList from '../../components/DealerJobList'

import {
  fetchDealers,
  deleteDealer,
} from '../../store/actions'

import './index.css'
import DeleteDealerModal from './DeleteDealerModal'
import api from '../../api'

const defaultSummary = {
  bins: 0,
  parts: 0,
  quantity: 0,
}

const DealerInfo = (props) => {
  const [ dealer, setDealer ] = useState(null)
  const [ isShowDeleteDealerModal, setIsShowDeleteDealerModal ] = useState(false)
  const [ summary, setSummary ] = useState(null)
  useEffect(() => {
    (async function () {
      !props.dealerList.length && props.fetchDealers()
      !summary && api.getCountingSummaryByDealer(props.match.params.dealerId).then(res => {
        const data = res.data.data
        setSummary(data ? {
          bins: data.binCount,
          parts: data.partNumberCount,
          quantity: data.itemCount,
        } : defaultSummary)
      })
    })()
  }, [])

  useEffect(() => {
    if (!props.dealerList.length) {
      return
    }
    const dealer = [ ...props.dealerList,
      ...props.searchedDealerList ].find(dealer => props.match.params.dealerId === dealer.UUID)
    setDealer(dealer)
  }, [ props.dealerList ])

  const toggleDeleteDealerModal = () => {
    setIsShowDeleteDealerModal(!isShowDeleteDealerModal)
  }

  const onDelete = async (reason) => {
    props.deleteDealer(dealer, reason, () => props.history.push('/dealers'))
  }

  return (
    <div>
      <MainHeader title={dealer ? dealer.name : ''} backLink="/dealers" />
      <MainView>
        {dealer &&
         <div className="dealer-info">
           <div className="dealer-info__left-bar">
             <DealerDetails dealer={dealer} onDeleteDealer={toggleDeleteDealerModal} summary={summary} />
           </div>
           <div className="dealer-info__right-bar">
             <DealerJobList dealer={dealer} />
           </div>
         </div>
        }
      </MainView>
      {isShowDeleteDealerModal &&
       <DeleteDealerModal
         onClose={toggleDeleteDealerModal}
         title={dealer.name}
         onDelete={onDelete}
       />}

    </div>
  )
}

const mapStateToProps = ({
                           dealers:
                             {
                               dealerList,
                               dealerSearch: {
                                 searchedDealerList,
                               },
                             },
                         }) => ({
  dealerList,
  searchedDealerList,
})

export default connect(mapStateToProps, { fetchDealers, deleteDealer })(withRouter(DealerInfo))
